module.exports = require("./lag.js");